<template>
  <div class="product-item-info card h-100">
    <RichOfferContent
      v-if="isRichContentMode"
      :html="decodedArgument1"
      :product="product"
      :step="step"
      :order-type="orderType"
      :fill-product-with-choice="fillProductWithChoice"
      :default-choice-id="getDefaultChoice(product).id || ''"
    />
    <template v-else>
      <div
        class="extra-product-before"
        v-if="showBeforeText"
        v-html="renderHTML(getDefaultChoice(product).argument1)"
      ></div>
      <ProductListImage
        :product="product"
        :isProductListFromParent="isProductListFromParent"
      />
      <div class="product-item-details card-body">
        <h3 class="product-item-name">
          <a class="product-item-link" :href="product.url">
            {{ product.name }}
          </a>
        </h3>
        <Ratings
          v-if="showratingstar && !product.hideCustomerReviews"
          mode="skeepers_product__stars"
          :productCodeFromParent="product.code"
        ></Ratings>
        <p class="listing-long-name">
          {{ product.longName }}
        </p>
        <a class="know-more" :href="product.url">
          <span>{{ $t("labels.more") }}</span>
        </a>
      </div>
      <div class="card-footer product-item-details-button">
        <template v-if="getDefaultChoice(product)">
          <Price :product="getDefaultChoice(product)" class="price-container" />
        </template>
        <template v-if="showaddtocart && getDefaultChoice(product)">
          <AddToCart
            :item="fillProductWithChoice(product)"
            :btnlabel="addToCartLabel"
          />
        </template>
        <template v-else-if="showprocessorder && getDefaultChoice(product)">
          <CheckoutButtonProcessOrder
            :item="fillProductWithChoice(product)"
            :step="step"
            :type="orderType"
            :processordertext="renderHTML(getDefaultChoice(product).argument2)"
          />
        </template>
        <a class="know-more" v-else :href="product.url">
          <span>{{ $t("labels.more") }}</span>
        </a>
      </div>
      <div
        class="extra-product-after"
        v-if="showAfterText"
        v-html="renderHTML(getDefaultChoice(product).argument3)"
      ></div>
    </template>
  </div>
</template>

<script>
import AddToCart from "@/components/AddToCart.vue";
import Price from "@/components/productlist/subcomponents/Price.vue";
import Ratings from "@/components/product/Ratings.vue";
import ProductListImage from "@/components/productlist/subcomponents/Image.vue";
import CheckoutButtonProcessOrder from "@/components/checkout/ButtonProcessOrder.vue";
import RichOfferContent from "@/components/productlist/subcomponents/RichOfferContent.vue";
import { hasRichOfferMarker } from "@/services/richOfferParser";

export default {
  name: "Product",
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
    categoryid: {
      type: String,
      default: "",
    },
    showaddtocart: {
      type: Boolean,
      default: false,
    },
    addToCartLabel: {
      type: String,
    },
    showprocessorder: {
      type: Boolean,
      default: false,
    },
    step: {
      type: Number,
      default: 0,
    },
    showBeforeText: {
      type: Boolean,
      default: false,
    },
    showAfterText: {
      type: Boolean,
      default: false,
    },
    showratingstar: {
      type: Boolean,
      default: false,
    },
    getDefaultChoice: {
      type: Function,
      required: true,
    },
    fillProductWithChoice: {
      type: Function,
      required: true,
    },
    isProductListFromParent: {
      type: Boolean,
      default: false,
    },
    orderType: {
      type: String,
      default: "crosssell",
    },
  },
  components: {
    ProductListImage,
    Price,
    AddToCart,
    Ratings,
    CheckoutButtonProcessOrder,
    RichOfferContent,
  },
  computed: {
    /**
     * FORGE-264 — salesforce `argument1` arrives URL-encoded in most flows
     * (consistent with the rest of the app which routes through `renderHTML`
     * = `decodeURIComponent`). Decode once here so both the marker detection
     * and the RichOfferContent parser work on the real HTML string.
     */
    decodedArgument1() {
      const raw = this.getDefaultChoice(this.product)?.argument1 || "";
      return this.renderHTML(raw);
    },
    /**
     * FORGE-264 — switches to the unified rich-content renderer
     * when the marketer inserted at least one .op-cta marker in Argument1__c.
     * Falls back to the legacy 3-field layout (before / CTA / after) otherwise.
     *
     * We run the predicate on the DECODED HTML because legacy content is
     * URL-encoded in DynamoDB and the marker would never match `<div …>`
     * on the raw percent-encoded string.
     */
    isRichContentMode() {
      if (!this.showprocessorder) return false;
      const decoded = this.decodedArgument1;
      if (!decoded) return false;
      return hasRichOfferMarker(decoded);
    },
  },
};
</script>
